{
  "chargeShards": 30,
  "rideDurationMs": 5000,
  "summonMs": 400,
  "dismountInvulnMs": 500,
  "maxSpeedPct": 100,
  "shockTierPx": 64,
  "rides": {
    "jet_snail": { "speedPct": 45, "ability": "dash", "ignoresSlow": true },
    "thundertoad": {
      "speedPct": 20,
      "ability": "shockwave",
      "jumpVelocityPct": 130,
      "shockRadiusPx": 96,
      "shockStunMs": 1000
    },
    "wobblebot": { "speedPct": 25, "ability": "bulldoze", "bumpStunMs": 800 },
    "pufferloon": {
      "speedPct": 15,
      "ability": "glide",
      "fallSpeedPct": 30,
      "glideLiftPxPerSec": 120
    },
    "drillmole": { "speedPct": 30, "ability": "burrow", "burrowMs": 1500 },
    "crabwalker": {
      "speedPct": 20,
      "ability": "shell",
      "blocksProjectiles": true,
      "bumpStunMs": 800
    }
  }
}
